<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row">
        <div
          class="card_container"
          style="flex: 0 0 20%; border-radius: 10px; flex: 0 0 24%"
        >
          <div class="row align-items-center fuel_consumption_buttons_row">
            <div class="col-md-6 mt-3 fuel_consumption_btn_div">
              <div
                class="fuel_consumption_button"
                @click="activateTab('change_price')"
                :class="[activeTab === 'change_price' ? 'active_tab' : null]"
              >
                <img src="@/assets/img/random.svg" width="60%" />
              </div>
              <div class="text-center tab" style="font-size: 12px">
                {{ $t("text.priceManagement.title") }}
              </div>
            </div>
            <!-- <div class="col-md-4 fuel_consumption_btn_div mt-3">
              <div
                class="fuel_consumption_button"
                @click="activateTab('price_change_log')"
                :class="[
                  activeTab === 'price_change_log' ? 'active_tab' : null,
                ]"
              >
                <img src="@/assets/img/list (2).svg" width="35px" />
              </div>
              <div class="text-center tab" style="font-size: 12px">
                {{ $t("text.priceManagement.priceChangeLog") }}
              </div>
            </div> -->
            <!-- APPROVALS -->
            <div class="col-md-6 mt-3 fuel_consumption_btn_div">
              <div
                class="fuel_consumption_button"
                @click="activateTab('price_approval')"
                :class="[activeTab === 'price_approval' ? 'active_tab' : null]"
              >
                <img src="@/assets/img/list (2).svg" width="60%" />
              </div>
              <div class="text-center tab" style="font-size: 12px">
                {{ $t("text.priceManagement.priceChangeLog") }}
                <!-- Approval -->
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuel_consumption_row_right_section mr-3 pump__bg"
          style="border-radius: 12px; flex: 0 0 72%"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(41, 39, 39 , 0.92), rgb(41, 39, 39, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div
            class="row align-items-center justify-content-center"
            style="height: 100%"
          >
            <div
              class="col-md-12"
              style="display: flex; justify-content: center"
            >
              <h4 class="text-center text-white">
                {{ $t("text.priceManagement.companyPriceUpdate") }}
              </h4>
            </div>
          </div>
          <div class="transaction_period_text text-center mt-5"></div>
        </div>
      </div>
      <section
        class="mt-3 pump__details__section_2"
        v-show="activeTab === 'change_price'"
      >
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-6" style="padding-right: 0px">
            <div class="drivers_list">
              <div class="product_summary__wrapper" style="padding: 1px">
                <div class="text-center mt-4">
                  <img src="@/assets/img/shuffle (2).svg" width="" />
                  <h3 class="change_price_header">
                    {{ $t("text.priceManagement.title") }}
                  </h3>
                </div>
                <div class="price_change_form_section mt-5">
                  <form>
                    <div class="row align-items-center justify-content-center">
                      <div class="col-md-12">
                        <label>{{
                          $tc("text.priceManagement.selectZone", 1)
                        }}</label>
                        <div class="price_change_input_wrapper">
                          <select v-model="zone" v-on:change="zoneChange">
                            <option
                              :value="$tc('text.priceManagement.selectZone', 2)"
                            >
                              {{ $tc("text.priceManagement.selectZone", 2) }}
                            </option>
                            <option
                              :value="zn.id"
                              v-for="(zn, i) in zones"
                              :key="i"
                            >
                              {{ zn.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <!-- state  -->

                    <div
                      v-if="zoneId"
                      class="row align-items-center justify-content-center mt-3"
                    >
                      <div class="col-md-12">
                        <label>{{
                          $tc("text.priceManagement.selectState", 1)
                        }}</label>
                        <section class="d-flex">
                          <div class="price_change_input_wrapper">
                            <multiselect
                              v-model="state"
                              :options="states"
                              :multiple="true"
                              :close-on-select="false"
                              :clear-on-select="false"
                              :preserve-search="true"
                              :loading="stateLoader"
                              :placeholder="$t('text.omit.pickOrSearch')"
                            >
                            </multiselect>

                            <!-- <select v-model="state">
                              <option
                                :value="
                                  $tc('text.priceManagement.selectState', 2)
                                "
                              >
                                {{ $tc("text.priceManagement.selectState", 2) }}
                              </option>
                              <option
                                v-for="(state, i) in states"
                                :value="state"
                                :key="i"
                              >
                                {{ state }}
                              </option>
                            </select> -->
                          </div>
                          <!-- <img
                            src="@/assets/img/git_loader.gif"
                            style="display: none"
                            width="20px"
                            height="20px"
                            class="ml-3 loader4 mt-2"
                          /> -->
                        </section>
                      </div>
                    </div>
                    <!--  -->

                    <!-- product  -->

                    <div
                      class="row align-items-center mt-3 justify-content-center"
                    >
                      <div class="col-md-12">
                        <label>{{
                          $t("text.priceManagement.selectProduct")
                        }}</label>
                        <div class="price_change_input_wrapper">
                          <select v-model="product">
                            <option
                              :value="
                                $t('text.priceManagement.selectProductSmall')
                              "
                            >
                              {{
                                $t("text.priceManagement.selectProductSmall")
                              }}
                            </option>
                            <option
                              :value="prod.productId"
                              v-for="(prod, i) in prodList"
                              :key="i"
                            >
                              {{ prod.productName }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <!--  -->
                    <div
                      class="row align-items-center mt-3 justify-content-center"
                    >
                      <div class="col-md-12">
                        <label>{{
                          $tc("text.priceManagement.newPrice", 1)
                        }}</label>
                        <div class="price_change_input_wrapper">
                          <input
                            type="number"
                            class="border-0"
                            min="0"
                            v-model="priceVal"
                            :placeholder="
                              $tc('text.priceManagement.newPrice', 2)
                            "
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3 justify-content-center;">
                      <div class="col-md-12">
                        <label>{{
                          $t("text.priceManagement.retailOutlets")
                        }}</label>
                        <div class="price_change_input_wrapper">
                          <div
                            @click="toggleBranchListDropdown"
                            style="padding: 5px"
                          >
                            <vue-tags-input
                              v-model="tag"
                              :tags="tags"
                              @tags-changed="(newTags) => (tags = newTags)"
                            />
                          </div>

                          <div class="">
                            <div class="search__wrapper">
                              <div class="row align-items-center">
                                <div class="col-md-10">
                                  <input
                                    type="search"
                                    :placeholder="
                                      $t(
                                        'text.priceManagement.searchRetailOutlets',
                                      )
                                    "
                                    v-model="searchInp"
                                  />
                                </div>
                                <div class="col-md-2">
                                  <i
                                    class="fa fa-search"
                                    aria-hidden="true"
                                    style="color: #b6b6b6"
                                  ></i>
                                </div>
                              </div>
                            </div>
                            <div
                              class="row mt-3"
                              style="width: 100%; margin: 0 auto"
                            >
                              <div class="col-md-4">
                                <div classs="">
                                  <b-form-checkbox
                                    id="selectAll"
                                    v-model="selectAll"
                                    class="sec_text_color"
                                  >
                                    {{
                                      $t(
                                        "text.priceManagement.selectAllRetailOutlets",
                                      )
                                    }}
                                  </b-form-checkbox>
                                </div>
                              </div>
                            </div>
                            <div
                              class="row justify-content-center mt-3"
                              style="width: 100%; margin: 0 auto"
                            >
                              <div class="col-md-4">
                                <div class="">
                                  <b-form-group
                                    label=""
                                    v-on:click.native="toggleChckBox($event)"
                                  >
                                    <b-form-checkbox-group
                                      v-model="selected"
                                      :options="filteredList"
                                      name="flavour-2a"
                                      stacked
                                    >
                                    </b-form-checkbox-group>
                                  </b-form-group>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <b-form-group
                                  label=""
                                  v-on:click.native="toggleChckBox($event)"
                                >
                                  <b-form-checkbox-group
                                    v-model="selected"
                                    :options="filteredList2"
                                    name="flavour-2a"
                                    stacked
                                  >
                                  </b-form-checkbox-group>
                                </b-form-group>
                              </div>
                              <div class="col-md-4">
                                <b-form-group
                                  label=""
                                  v-on:click.native="toggleChckBox($event)"
                                >
                                  <b-form-checkbox-group
                                    v-model="selected"
                                    :options="filteredList3"
                                    name="flavour-2a"
                                    stacked
                                  >
                                  </b-form-checkbox-group>
                                </b-form-group>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- 🚨 PRICE CHANGES ARE NOW MANAGED ON OUR NEW PORTAL -->
                    <PriceChange />
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6" style="">
            <div class="drivers_list">
              <div
                class="recently_updated_wrapper"
                style="padding: 1px; height: 130px"
              >
                <div class="recently_updated">
                  <img src="@/assets/img/clock (4).svg" width="50px" />
                  <h4 class="recently_updated_text mt-3">
                    {{ $t("text.priceManagement.recentlyUpdated") }}
                  </h4>
                </div>
              </div>
              <TableLoader :showLoader="priceChangeLogLoader" />

              <div v-show="!priceChangeLogLoader">
                <div
                  class="recently_updated_wrapper mt-2"
                  style="padding: 1px"
                  v-for="(x, i) in recentlyUpdated"
                  :key="i"
                  v-show="i <= 3 || showAll"
                >
                  <div style="height: 50px">
                    <tr
                      class="row align-items-center justify-content-center"
                      style="height: 100%; border-bottom: 1px solid #eeeeef"
                    >
                      <th class="col-4 flexify-item">
                        <h3
                          v-if="x.branch.PMS"
                          class="recently_updated_header__branch_text_bold ml-2 responsive-text"
                        >
                          {{ x.branch.PMS.branchName }}
                        </h3>
                      </th>
                      <div class="col-8">
                        <div
                          class="row align-items-center justify-content-center"
                        >
                          <th
                            class="col-3 flexify-item"
                            v-if="
                              availableProducts.includes(
                                countryProducts.productsLower.product1,
                              )
                            "
                          >
                            <h3
                              class="recently_updated_header__branch_text_bold"
                            >
                              {{ countryProducts.products.product1 }}
                            </h3>
                          </th>
                          <th
                            class="col-3 flexify-item"
                            v-if="
                              availableProducts.includes(
                                countryProducts.productsLower.product2,
                              )
                            "
                          >
                            <h3
                              class="recently_updated_header__branch_text_bold"
                            >
                              {{ countryProducts.products.product2 }}
                            </h3>
                          </th>
                          <th
                            class="col-3 flexify-item"
                            v-if="
                              availableProducts.includes(
                                countryProducts.productsLower.product3,
                              )
                            "
                          >
                            <h3
                              class="recently_updated_header__branch_text_bold"
                            >
                              {{ countryProducts.products.product3 }}
                            </h3>
                          </th>
                          <th
                            class="col-3 flexify-item"
                            v-if="
                              availableProducts.includes(
                                countryProducts.productsLower.product4,
                              )
                            "
                          >
                            <h3
                              class="recently_updated_header__branch_text_bold"
                            >
                              {{ countryProducts.products.product4 }}
                            </h3>
                          </th>
                        </div>
                      </div>
                    </tr>
                  </div>

                  <div style="height: 50px">
                    <tr class="row align-items-center" style="height: 100%">
                      <td class="col-4 flexify-item">
                        <h3
                          class="recently_updated_header__branch_text_light ml-2 sec_text_color"
                        >
                          {{ $t("text.priceManagement.formerPrice") }}
                        </h3>
                      </td>
                      <div class="col-8">
                        <div
                          class="row align-items-center justify-content-center"
                        >
                          <td
                            class="col-3 flexify-item"
                            v-if="
                              availableProducts.includes(
                                countryProducts.productsLower.product1,
                              ) && x.branch.PMS
                            "
                          >
                            <h3
                              class="recently_updated_header__branch_text_bold sec_text_color"
                            >
                              {{ convertThousand(x.branch.PMS.previousPrice) }}
                            </h3>
                          </td>
                          <td
                            class="col-3 flexify-item"
                            v-if="
                              availableProducts.includes(
                                countryProducts.productsLower.product2,
                              ) && x.branch.AGO
                            "
                          >
                            <h3
                              class="recently_updated_header__branch_text_bold sec_text_color"
                            >
                              {{ convertThousand(x.branch.AGO.previousPrice) }}
                            </h3>
                          </td>
                          <td
                            class="col-3 flexify-item"
                            v-if="
                              availableProducts.includes(
                                countryProducts.productsLower.product3,
                              ) && x.branch.DPK
                            "
                          >
                            <h3
                              class="recently_updated_header__branch_text_bold sec_text_color"
                            >
                              {{ convertThousand(x.branch.DPK.previousPrice) }}
                            </h3>
                          </td>
                          <td
                            class="col-3 flexify-item"
                            v-if="
                              availableProducts.includes(
                                countryProducts.productsLower.product4,
                              ) && x.branch.LPG
                            "
                          >
                            <h3
                              class="recently_updated_header__branch_text_bold sec_text_color"
                            >
                              {{ convertThousand(x.branch.LPG.previousPrice) }}
                            </h3>
                          </td>
                        </div>
                      </div>
                    </tr>
                  </div>

                  <div style="height: 50px">
                    <tr
                      class="row align-items-center justify-content-center"
                      style="height: 100%"
                    >
                      <td class="col-4 flexify-item">
                        <h3
                          class="recently_updated_header__branch_text_light ml-2 sec_text_color"
                        >
                          {{ $t("text.priceManagement.updatedPrice") }}
                        </h3>
                      </td>
                      <div class="col-8">
                        <div
                          class="row align-items-center justify-content-center"
                        >
                          <td
                            class="col-3 flexify-item"
                            v-if="
                              availableProducts.includes(
                                countryProducts.productsLower.product1,
                              ) && x.branch.PMS
                            "
                          >
                            <h3
                              class="recently_updated_header__branch_text_bold"
                              :class="
                                x.branch.PMS.priceChanged
                                  ? 'green__text'
                                  : 'red__text'
                              "
                            >
                              {{ convertThousand(x.branch.PMS.currentPrice) }}
                            </h3>
                          </td>
                          <td
                            class="col-3 flexify-item"
                            v-if="
                              availableProducts.includes(
                                countryProducts.productsLower.product2,
                              ) && x.branch.AGO
                            "
                          >
                            <h3
                              class="recently_updated_header__branch_text_bold"
                              :class="
                                x.branch.AGO.priceChanged
                                  ? 'green__text'
                                  : 'red__text'
                              "
                            >
                              {{ convertThousand(x.branch.AGO.currentPrice) }}
                            </h3>
                          </td>

                          <td
                            class="col-3 flexify-item"
                            v-if="
                              availableProducts.includes(
                                countryProducts.productsLower.product3,
                              ) && x.branch.DPK
                            "
                          >
                            <h3
                              class="recently_updated_header__branch_text_bold"
                              :class="
                                x.branch.DPK.priceChanged
                                  ? 'green__text'
                                  : 'red__text'
                              "
                            >
                              {{ convertThousand(x.branch.DPK.currentPrice) }}
                            </h3>
                          </td>
                          <td
                            class="col-3 flexify-item"
                            v-if="
                              availableProducts.includes(
                                countryProducts.productsLower.product4,
                              )
                            "
                          >
                            <h3
                              class="recently_updated_header__branch_text_bold"
                              :class="
                                x.branch.LPG.priceChanged
                                  ? 'green__text'
                                  : 'red__text'
                              "
                            >
                              {{ convertThousand(x.branch.LPG.currentPrice) }}
                            </h3>
                          </td>
                        </div>
                      </div>
                    </tr>
                  </div>
                </div>
              </div>

              <div class="mt-2 mb-5" style="padding: 1px; height: 120px">
                <div class="recently_updated">
                  <div class="text-center">
                    <!-- @click="toggleShowAll" -->
                    <button
                      class="ep-btn ep-primary"
                      :disabled="isButtonDisabled ? true : null"
                      ref="toggleShow"
                      @click="activateTab('price_approval')"
                      :style="[
                        isButtonDisabled
                          ? { cursor: 'not-allowed' }
                          : { cursor: 'pointer' },
                      ]"
                    >
                      {{ $t("text.priceManagement.viewMore") }}<span></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- PRICE CHANGE LOG -->
      <section
        class="mt-3 pump__details__section_2"
        style="width: 98.5%"
        v-show="activeTab === 'price_change_log'"
      >
        <!-- ADDED DATE RANGE -->
        <div class="row">
          <div class="col-md-6"></div>
          <div class="drop_down_div align-items-center col-md-6">
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :locale="this.$root.$i18n.locale"
              :color="$store.getters.getDatePickerColor"
              format="DDMMYYYY"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.dateRange')"
            />
          </div>
        </div>

        <div class="col-md-12 col-lg-12 mt-3">
          <ejs-grid
            v-show="!showLoader"
            ref="dataGrid"
            :created="refreshGrid"
            :allowPaging="true"
            :allowSorting="true"
            :pageSettings="pageSettings"
            :toolbar="toolbar"
            :searchSettings="search"
            :allowExcelExport="true"
            :allowPdfExport="true"
            :toolbarClick="toolbarClick"
            :rowDataBound="rowDataBound"
            :excelQueryCellInfo="excelQueryCellInfo"
            :locale="usedLang"
          >
            <e-columns>
              <e-column width="40" field="index" headerText="#"></e-column>
              <e-column
                field="date"
                width="270"
                :sortComparer="sortComparer"
                :headerText="$t('text.priceManagement.date')"
              ></e-column>
              <e-column
                field="branchName"
                width="320"
                :headerText="$t('text.priceManagement.branchName')"
              ></e-column>
              <e-column
                field="product"
                width="150"
                :headerText="$t('text.priceManagement.product')"
              ></e-column>
              <e-column
                width="150"
                field="currentPrice"
                :sortComparer="sortComparer2"
                :headerText="$t('text.priceManagement.currentPrice')"
              ></e-column>
              <e-column
                width="150"
                field="previousPrice"
                :sortComparer="sortComparer2"
                :headerText="$t('text.priceManagement.previousPrice')"
              ></e-column>
              <e-column
                field="changedBy"
                width="300"
                :headerText="$t('text.priceManagement.changedBy')"
              ></e-column>
            </e-columns>
          </ejs-grid>
          <TableLoader :showLoader="showLoader" />
        </div>
      </section>

      <!-- APPROVAL TABLE -->
      <section
        class="mt-3 pump__details__section_2"
        style="width: 98.5%"
        v-show="activeTab === 'price_approval'"
      >
        <div class="row">
          <div class="col-md-6"></div>
          <div class="drop_down_div align-items-center col-md-6">
            <vue-ctk-date-time-picker
              v-model="dateRange2"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :locale="this.$root.$i18n.locale"
              :color="$store.getters.getDatePickerColor"
              format="DDMMYYYY"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.dateRange')"
            />
          </div>
        </div>

        <div class="col-md-12 col-lg-12 mt-3">
          <ejs-grid
            v-show="!showLoader"
            ref="dataGrid2"
            :created="refreshGrid2"
            :allowPaging="true"
            :allowSorting="true"
            :pageSettings="pageSettings"
            :toolbar="toolbar"
            :searchSettings="search"
            :allowExcelExport="true"
            :allowPdfExport="true"
            :toolbarClick="toolbarClick2"
            :rowDataBound="rowDataBound"
            :excelQueryCellInfo="excelQueryCellInfo"
            :locale="usedLang"
          >
            <e-columns>
              <e-column width="40" field="index" headerText="#"></e-column>
              <e-column
                field="date"
                width="270"
                :sortComparer="sortComparer"
                :headerText="$t('text.priceManagement.date')"
              ></e-column>
              <e-column
                field="branchNames"
                width="320"
                :headerText="$t('text.priceManagement.branchName')"
              ></e-column>
              <e-column
                field="product"
                width="150"
                :headerText="$t('text.priceManagement.product')"
              ></e-column>
              <e-column
                width="150"
                field="price"
                :sortComparer="sortComparer2"
                :headerText="$t('text.priceManagement.currentPrice')"
              ></e-column>
              <e-column
                width="150"
                field="oldPrice"
                :sortComparer="sortComparer2"
                :headerText="$t('text.priceManagement.previousPrice')"
              ></e-column>
              <e-column
                field="changedBy"
                width="300"
                :headerText="$t('text.priceManagement.changedBy')"
              ></e-column>
              <e-column
                width="350"
                :template="PriceChangeTemp"
                headerText=""
              ></e-column>
              <!-- <e-column
                v-if="
                  PriceApproval ||
                  userInfo.roles.includes('SupportAdmin') ||
                  userInfo.roles.includes('Super Admin')
                "
                width="350"
                :template="PriceChangeTemp"
                headerText=""
              ></e-column> -->
              <!-- <e-column
                v-else
                width="150"
                field="status"
                :headerText="$t('text.actionButtons.status')"
              ></e-column> -->
            </e-columns>
          </ejs-grid>
          <TableLoader :showLoader="showLoader" />
        </div>
      </section>
    </MasterLayout>
    <div
      style="position: fixed"
      v-bind:class="[
        'update_modal',
        showUpdateModal ? 'show_update_modal' : 'hide_update_modal',
      ]"
    >
      <p class="update_modal_text">
        {{ $t("text.priceManagement.putPassword") }}
      </p>
      <input
        :placeholder="$t('text.priceManagement.password')"
        v-model="password"
        type="password"
        class="update_modal_input"
        ref="password"
      />

      <!-- Token shows if user roles contain support admin -->
      <div v-show="userDetails.roles.includes('SupportAdmin')">
        <div class="mt-3" v-show="sendingTok">
          <p class="update_modal_text text-danger text-center">
            {{ $t("text.priceManagement.sendingToken") }} {{ userInfo.email }}
            <span>
              <img
                src="@/assets/img/git_loader.gif"
                style="display: none"
                width="30px"
                class="ml-3 loader3 mt-3"
            /></span>
          </p>
        </div>

        <div class="mt-3" v-show="!sendingTok && !cddStopped">
          <p class="update_modal_text">
            {{ $t("text.priceManagement.putToken") }}
          </p>
          <input
            :placeholder="$t('text.priceManagement.token')"
            v-model="token"
            type="number"
            class="update_modal_input"
            ref="token"
          />
          <p
            class="update_modal_text text-danger text-center font-weight-bold"
            style="font-size: 14px"
          >
            {{ $t("text.priceManagement.tokenExpire") }} ({{ userInfo.email }})
            {{ $t("text.priceManagement.tokenExpire2") }}
            <span id="countdown"></span>
          </p>
        </div>
        <div
          class="mt-3 text-center text-danger border border-danger rounded"
          v-if="cddStopped"
          @click="sendTokenMail"
          style="cursor: pointer"
        >
          <p style="font-size: 12px" class="my-auto flicker-text">
            {{ $t("text.priceManagement.tokenExpired") }}
          </p>
        </div>
      </div>

      <div class="update_modal_actions">
        <button @click="stopCountdown" class="update_cancel_button">
          {{ $t("text.priceManagement.cancel") }}
        </button>
        <button @click="updatePrice($event)" class="update_submit_button">
          {{ $t("text.priceManagement.submit") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/MobileWallet.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import countryProducts from "@/products";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import VueTagsInput from "@johmun/vue-tags-input";
import TableLoader from "@/components/tableLoader/index";
import PriceChangeTemp from "@/components/Templates/approvePriceChangeTemp";
import PriceChange from "@/components/PriceChange.vue";
import Multiselect from "vue-multiselect";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Price Management :: Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    VueTagsInput,
    TableLoader,
    PriceChangeTemp,
    PriceChange,
    Multiselect,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      states: [],
      state: null,
      stateLoader: false,

      usedLang: this.$store.getters.getLanguage,
      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      selected: [],
      date_theme: "purple",
      priceVal: "",
      options: [],
      options2: [],
      options3: [],
      theme: "#370F70",
      schedulePriceChangeDate: "2020-07-09 20:26",
      schedulePriceChangeTime: "",
      combinedOptions: [],
      backgroundUrl,
      password: null,

      token: null,
      sendingTok: true,
      userInfo: JSON.parse(localStorage.getItem("userDetails")),
      PriceApproval: JSON.parse(localStorage.getItem("PriceApproval")),
      countdownT: null,
      cddStopped: false,

      tag: "",
      tags: [],
      zones: [],
      datePeriod: "now",
      zoneId: null,
      availableProducts: [],
      company: null,
      cardBackgroundUrl,
      searchInp: "",
      prodArray: [],
      recentlyUpdated: [],
      showUpdateModal: false,
      price: "",
      branches: [],
      prodList: [],
      showAll: false,
      zone: this.$tc("text.priceManagement.selectZone", 2),
      product: this.$t("text.priceManagement.selectProductSmall"),
      showLoader: false,
      isButtonDisabled: null,
      activeTab: "change_price",
      showBranchListDropDown: false,
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      startDate2: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate2: this.$moment().format("MMMM D, YYYY"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      pluginStartDate2: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate2: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate2, end: this.pluginEndDate2 },
      dateRange2: { start: this.pluginStartDate2, end: this.pluginEndDate2 },
      priceChangeLogLoader: false,
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      approvalList: [],
      PriceChangeTemp: function () {
        return {
          template: PriceChangeTemp,
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.checkViewOnly();
      this.getZones();
      this.getProducts();
      this.getBranches();
      // this.getPriceLog();
      this.getRecentlyPriceChangeLog();
      this.getHistoryChartsData();
    }
    this.getToday();

    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
    this.dateRange2.start = this.pluginStartDate2;
    this.dateRange2.end = this.pluginEndDate2;
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
    filteredList() {
      const sortedList = [...this.options];

      sortedList.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });

      return sortedList.filter((ch, i) =>
        ch.text.toLowerCase().includes(this.searchInp.toLowerCase()),
      );
    },
    filteredList2() {
      const sortedList = [...this.options2];
      sortedList.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      return sortedList.filter((ch, i) =>
        ch.text.toLowerCase().includes(this.searchInp.toLowerCase()),
      );
    },
    filteredList3() {
      const sortedList = [...this.options3];
      sortedList.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      return sortedList.filter((ch, i) =>
        ch.text.toLowerCase().includes(this.searchInp.toLowerCase()),
      );
    },
    selectAll: {
      get: function () {},
      set: function (value) {
        let selected = [];
        let combinedArray = [
          ...this.options,
          ...this.options2,
          ...this.options3,
        ];
        if (!value) {
          this.selected = selected;
          this.tags = selected;
          return;
        }
        if (value) {
          combinedArray.forEach(function (opt) {
            selected.push(opt.value);
          });
          this.selected = selected;
          this.tags = selected;
        }
      },
    },
    userDetails: {
      get() {
        const user = localStorage.getItem("userDetails")
          ? JSON.parse(localStorage.getItem("userDetails"))
          : null;

        if (user) {
          if (!user.roles) {
            if (user.role) {
              user.roles = user.role.split(",");
              localStorage.setItem("userDetails", JSON.stringify(user));
            }
          }
        }
        return user;
      },
      set(value) {},
    },
  },
  watch: {
    state(newState) {
      if (newState) {
        this.getBranches();
      }
    },

    product(newVal) {
      if (newVal) {
        this.getBranches();
      }
    },
    // dateRange: function (newRange, oldRange) {
    //   if (newRange.start !== null && newRange.end !== null) {
    //     this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
    //       "MMMM D, YYYY"
    //     );
    //     this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
    //       "MMMM D, YYYY"
    //     );
    //     this.getPriceLog();
    //   }
    // },
    dateRange2: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate2 = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY",
        );
        this.endDate2 = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY",
        );
        this.getApprovalList();
      }
    },
    company(company) {
      if (company !== null) {
        this.checkViewOnly();
        this.getZones();
        this.getProducts();
        this.getBranches();
        // this.getPriceLog();
        this.getRecentlyPriceChangeLog();
        this.getHistoryChartsData();
      }
    },
    tags: function (newTags, oldTags) {
      let newSelectedArray = [];

      if (newTags.length === oldTags.length) {
        newTags.forEach((tg) => {
          newSelectedArray.push(tg);
        });
        this.selected = newSelectedArray;
      } else {
        newTags.forEach((tg) => {
          newSelectedArray.push(tg.text);
        });
      }
    },
    value: function () {
      if (this.value !== "") {
        this.$refs.date_label.style.display = "none";
      }
    },
  },
  methods: {
    sortComparer(reference, comparer) {
      reference = this.$moment(reference, "DD/MM/YYYY").format();
      comparer = this.$moment(comparer, "DD/MM/YYYY").format();
      if (reference < comparer) {
        return -1;
      } else if (reference > comparer) {
        return 1;
      } else {
        return 0;
      }
    },
    sortComparer2(reference, comparer) {
      reference = this.revertNumber(reference);
      comparer = this.revertNumber(comparer);
      return reference - comparer;
    },
    excelQueryCellInfo(args) {
      if (
        args.column.field == "currentPrice" ||
        args.column.field == "previousPrice"
      ) {
        args.value = this.revertNumber(args.value);
      }
    },
    checkViewOnly() {
      this.isButtonDisabled = this.$store.getters.getViewOnly;
    },
    getHistoryChartsData() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/CompanyFiveDaySale/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig(),
        )
        .then((response) => {
          response.data.forEach((el) => {
            this.companyProduct;
            this.availableProducts.push(el.product.toLowerCase());
          });
          this.paintSplineData(response.data);
        })
        .catch((error) => {});
    },

    rowDataBound: function (args) {
      if (args.data["priceChanged"] === true) {
        args.row.cells[3].style.color = "red";
      }
      if (args.data["priceChanged"] === false) {
        args.row.cells[3].style.color = "green";
      }
    },
    hideButton($event) {
      $event.preventDefault();
      $event.target.style.display = "none";
      this.$refs.update_later_div.style.display = "block";
    },

    toggleChSelectAllBox($event) {
      if ($event.target.checked) {
        $event.target.checked = false;
      } else {
        $event.target.checked = true;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    refreshGrid2() {
      this.$refs.dataGrid2.refresh();
    },
    toggleShowAll(event) {
      this.activeTab = "price_change_log";
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    toolbarClick2(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Price log.pdf",
          };
          this.$refs.dataGrid2.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          let excelExportProperties = {
            fileName: "Price log.xlsx",
          };
          this.$refs.dataGrid2.excelExport(excelExportProperties);
          break;
      }
    },

    activateTab(tab) {
      this.activeTab = tab;
      // if (this.activeTab === "price_change_log") {
      //   this.getPriceLog();
      // } else
      if (this.activeTab === "price_approval") {
        this.getApprovalList();
      }
    },
    toggleChckBox($event) {
      if ($event.target.checked) {
        if (!this.tags.includes($event.target.value)) {
          this.tags.push($event.target.value);
          const getIndex = this.selected.indexOf($event.target.value);
          if (getIndex === -1) {
            this.selected.push($event.target.value);
          } else {
            this.selected.splice(getIndex, 1);
          }
        }
      } else {
        if (this.tags.includes($event.target.value)) {
          const getIndex = this.tags.indexOf($event.target.value);
          this.tags.splice(getIndex, 1);
        }
      }
    },
    getToday() {
      let d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      var hours = d.getHours();
      var minutes = d.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      hours = hours < 10 ? "0" + hours : hours;
      var strTime = hours + ":" + minutes + " " + ampm;
      // var strTime = hours + ':' + minutes;

      let todaysDate = [year, month, day].join("-") + " " + strTime;
      this.schedulePriceChangeDate = todaysDate;
    },
    showModal($event, period) {
      $event.preventDefault();
      if (this.product === this.$t("text.priceManagement.selectProductSmall")) {
        this.$toast.open({
          message: this.$t("text.errors.productMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.priceVal) {
        this.$toast.open({
          message: this.$t("text.errors.priceFieldMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.priceVal <= 0) {
        this.$toast.open({
          message: this.$t("text.errors.invalidPrice"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.selected.length < 1) {
        this.$toast.open({
          message: this.$t("text.priceManagement.selectBranch"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      this.datePeriod = period;
      this.showUpdateModal = true;
      if (this.userDetails.roles.includes("SupportAdmin")) {
        this.sendTokenMail();
      }
    },

    sendTokenMail() {
      this.sendingTok = true;
      this.cddStopped = false;
      $(".loader3").show();

      let branchIds = [];
      this.combinedOptions.forEach((opt) => {
        if (this.selected.includes(opt.value)) {
          branchIds.push(opt.id);
        }
      });

      let data;

      data = {
        companyId: this.$route.query.companyId
          ? this.$route.query.companyId
          : this.company.id,
        zoneId:
          this.zone == this.$tc("text.priceManagement.selectZone", 2)
            ? null
            : this.zone,
        groupId: null,
        dealerId: null,
        branchIds: branchIds,
        newPrice: parseFloat(this.priceVal),
      };

      this.axios
        .post(
          `${configObject.apiBaseUrl}/Utilities/OTP/PriceChange`,
          data,
          configObject.authConfig(),
        )
        .then((response) => {
          $(".loader3").hide();
          this.sendingTok = false;
          this.startCountdown();
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },

    stopCountdown() {
      this.showUpdateModal = !this.showUpdateModal;
      if (this.userDetails.roles.includes("SupportAdmin")) {
        clearInterval(this.countdownT);
        this.token = null;
        document.getElementById("countdown").textContent = "0:00";
      }
    },

    startCountdown() {
      let stopCDD = () => {
        this.cddStopped = true;
        this.token = null;
      };

      const startingMinutes = 10;
      let time = startingMinutes * 60;

      const countdownT = setInterval(function () {
        const minutes = Math.floor(time / 60);
        let seconds = time % 60;

        seconds = seconds < 10 ? "0" + seconds : seconds;

        document.getElementById(
          "countdown",
        ).textContent = `${minutes}:${seconds}`;

        if (time == 0) {
          clearInterval(countdownT);
          document.getElementById("countdown").textContent = "0:00";
          stopCDD();
        }

        time--;
      }, 1000);

      this.countdownT = countdownT;
    },

    hidePriceSheduleDiv() {
      this.$refs.update_later_div.style.display = "none";
      this.$refs.update_later_btn_1.style.display = "block";
    },
    updatePrice($event) {
      $event.preventDefault();
      this.$refs.update_later_div.style.display = "none";
      this.$refs.update_later_btn_1.style.display = "block";

      if (!this.$refs.password.value) {
        this.$toast.open({
          message: this.$t("text.errors.passwordMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (!this.token && this.userDetails.roles.includes("SupportAdmin")) {
        this.$toast.open({
          message: this.$t("text.omit.tokenMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (this.datePeriod === "now") {
        $(".loader").show();
      } else {
        $(".loader2").show();
      }
      let passwordValue = this.$refs.password.value;
      let tokenValue = this.$refs.token.value;
      this.showUpdateModal = !this.showUpdateModal;
      this.$refs.password.value = "";
      this.$refs.token.value = "";
      let branchIds = [];
      this.combinedOptions.forEach((opt) => {
        if (this.selected.includes(opt.value)) {
          branchIds.push(opt.id);
        }
      });

      let data;

      let date;

      if (this.datePeriod === "later") {
        const dateTime = this.$moment(`${this.schedulePriceChangeDate}`).format(
          "YYYY-MM-DD HH:mm:ss",
        );
        let newDateTime = new Date(dateTime);
        let updatedDateTime = new Date(
          newDateTime.setHours(newDateTime.getHours() + 1),
        ).toISOString();
        date = updatedDateTime;
      } else {
        let priceDate = new Date();
        priceDate.setHours(priceDate.getHours() + 1);
        date = priceDate.toISOString();
      }

      if (this.zone === this.$tc("text.priceManagement.selectZone", 2)) {
        data = {
          zoneId: null,
          productId: this.product,
          price: parseFloat(this.priceVal),
          branchIds: branchIds,
          password: passwordValue,
          otp: tokenValue,
          scheduleDate: date,
          // id: this.$route.query.companyId
          //   ? this.$route.query.companyId
          //   : this.company.id,
          state: this.state ? this.state.join(",") : null,
        };
      } else {
        data = {
          // id: this.$route.query.companyId
          //   ? this.$route.query.companyId
          //   : this.company.id,
          zoneId: this.zone,
          productId: this.product,
          price: parseFloat(this.priceVal),
          branchIds: branchIds,
          password: passwordValue,
          otp: tokenValue,
          scheduleDate: date,
          state: this.state ? this.state.join(",") : null,
        };
      }

      let message = !this.schedulePriceChangeDate
        ? "Price change made Succesffuly"
        : "The Price Chnage would be effected at the due date";

      this.axios
        .post(
          `${configObject.apiBaseUrl}/v2/PriceChange/Company/ChangePrice`,
          data,
          configObject.authConfig(),
        )
        .then((response) => {
          this.password = "";
          this.token = "";
          clearInterval(this.countdownT);
          document.getElementById("countdown").textContent = "0:00";
          $(".loader").hide();
          $(".loader2").hide();
          this.$toast.open({
            message:
              response.status === 200
                ? this.$t("text.priceManagement.successfullyChanged")
                : response.data.message,
            type: "success",
            duration: 4000,
          });
          this.getRecentlyPriceChangeLog(this.zone);
          // this.getPriceLog();

          this.zone = this.$tc("text.priceManagement.selectZone", 2);
          this.product = this.$t("text.priceManagement.selectProductSmall");
          this.priceVal = "";
          this.state = null;
          this.tag = "";
          this.tags = [];
          this.selected = [];
          // this.selectAll = false;

          this.$refs.password.value = "";
          this.$refs.token.value = "";

          this.getToday();
        })
        .catch((error) => {
          this.password = "";
          this.token = "";
          clearInterval(this.countdownT);
          document.getElementById("countdown").textContent = "0:00";
          this.getToday();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          if (
            error.response.data.message ==
            "No Approvals set yet for Price Change"
          ) {
            this.$router.push({
              name: "price_managers",
              query: {
                entityType: "Company",
                new: true,
                companyId: this.$route.query.companyId,
              },
            });
          }
          $(".loader").hide();
          $(".loader2").hide();
        });
    },

    zoneChange(event) {
      this.zoneId = event.target.value;
      this.state = null;
      if (this.zone === this.$tc("text.priceManagement.selectZone", 2)) {
        this.getBranches();
        this.getRecentlyPriceChangeLog();
      } else {
        // this.getZoneBranches(event.target.value);
        this.getBranches();
        this.getRecentlyPriceChangeLog();
        this.getZoneStates();
        // this.getPriceLog();
      }
    },
    getRecentlyPriceChangeLog() {
      this.showLoader = true;
      // this.priceChangeLogLoader = true;
      let url = "";
      if (!this.zoneId) {
        url = `${configObject.apiBaseUrl}/Company/RecentPriceChangeLog/${
          this.$route.query.companyId
            ? this.$route.query.companyId
            : this.company.id
        }`;
      } else {
        url = `${configObject.apiBaseUrl}/Company/RecentPriceChangeLog/${
          this.$route.query.companyId
            ? this.$route.query.companyId
            : this.company.id
        }/${this.zoneId}`;
      }
      this.axios
        .get(url, configObject.authConfig())
        .then((response) => {
          this.showLoader = false;
          this.priceChangeLogLoader = false;
          const groupsObj = response.data.reduce((acc, cur) => {
            const bn = cur.branchName;
            if (!acc[bn]) {
              acc[bn] = { [cur.product]: cur };
            } else {
              acc[bn] = { ...acc[bn], [cur.product]: cur };
            }
            return acc;
          }, {});

          const newArray = Object.keys(groupsObj).map((cur) => {
            return {
              branch: groupsObj[cur],
            };
          });
          this.recentlyUpdated = newArray;
        })
        .catch((error) => {
          this.showLoader = false;
          this.priceChangeLogLoader = false;
        });
    },
    getZoneBranches(zoneId) {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Zones/Branches/${zoneId}`,
          configObject.authConfig(),
        )
        .then((response) => {
          this.showLoader = false;
          let copiedResponse = [...response.data];
          let options = [];
          let options2 = [];
          let options3 = [];
          copiedResponse.forEach((br, index) => {
            let dataLengthFirstOneThird = copiedResponse.length / 3;
            if (index <= dataLengthFirstOneThird) {
              options.push(br);
            }
          });
          let twoThirdOfArr = copiedResponse.splice(
            copiedResponse.length / 3 + 1,
            copiedResponse.length - 1,
          );
          twoThirdOfArr.forEach((br, index) => {
            let dataHalfList = parseInt(twoThirdOfArr.length / 2);
            if (index <= dataHalfList) {
              options2.push(br);
            } else {
              options3.push(br);
            }
          });

          this.combinedOptions = [...options, ...options2, ...options3];
          let index = 0;
          response.data.sort((a, b) => {
            if (a.dealerName === b.dealerName) {
              return a.name > b.name ? 1 : -1;
            }
            return a.dealerName > b.dealerName ? 1 : -1;
          });
          response.data.forEach((branch) => {
            index++;
            branch.index = index;
            branch.text = branch.name;
            branch.value = branch.name.toLowerCase();
          });
          this.options = options;
          this.options2 = options2;
          this.options3 = options3;

          this.options.sort((a, b) => {
            if (a.dealerName === b.dealerName) {
              return a.text > b.text ? 1 : -1;
            }
            return a.dealerName > b.dealerName ? 1 : -1;
          });
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getBranches() {
      this.showLoader = true;
      const zoneId = this.zoneId ? this.zoneId : "";
      const state = this.state ? this.state : "";
      const productId = this.product !== "Select Product" ? this.product : "";
      this.axios
        .get(
          `${
            configObject.apiBaseUrl
          }/v2/PriceChange/QualifiedBranches?companyId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }&zoneId=${zoneId}&state=${state}&productId=${productId}`,
          configObject.authConfig(),
        )
        .then((response) => {
          this.showLoader = false;
          const branches = response.data.data;

          let copiedResponse = [...response.data.data];

          let options = [];
          let options2 = [];
          let options3 = [];
          copiedResponse.forEach((br, index) => {
            let dataLengthFirstOneThird = copiedResponse.length / 3;
            if (index <= dataLengthFirstOneThird) {
              options.push(br);
            }
          });
          let twoThirdOfArr = copiedResponse.splice(
            copiedResponse.length / 3 + 1,
            copiedResponse.length - 1,
          );
          twoThirdOfArr.forEach((br, index) => {
            let dataHalfList = parseInt(twoThirdOfArr.length / 2);
            if (index <= dataHalfList) {
              options2.push(br);
            } else {
              options3.push(br);
            }
          });

          this.combinedOptions = [...options, ...options2, ...options3];

          let index = 0;
          branches.sort((a, b) => {
            return a.name > b.name ? 1 : -1;
          });
          branches.forEach((branch) => {
            index++;
            branch.index = index;
            branch.text = branch.name;
            branch.value = branch.name.toLowerCase();
          });
          this.options = options;
          this.options2 = options2;
          this.options3 = options3;

          this.options.sort((a, b) => {
            return a.name > b.name ? 1 : -1;
          });
        })
        .catch((error) => {});
    },
    getProducts() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Products/Company/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig(),
        )
        .then((response) => {
          this.showLoader = false;
          this.prodList = response.data;
        })
        .catch((error) => {});
    },
    convertThousand(request) {
      if (request === null || request === "null") {
        return "0.00";
      }
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getZoneStates() {
      this.stateLoader = true;
      // $(".loader4").show();
      this.axios
        .get(
          `${configObject.apiBaseUrl}/v2/PriceChange/BranchStates?companyId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }&zoneId=${this.zoneId}`,
          configObject.authConfig(),
        )
        .then((response) => {
          this.states = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {
          // $(".loader4").hide();
          this.stateLoader = false;
        });
    },
    getZones() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Zones/Company/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig(),
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });
          response.data.forEach((zone, index) => {
            zone.index = index + 1;
            const moment = zone.date
              .split("T")[0]
              .split("-")
              .reverse()
              .join("-");
            zone.date = this.$moment(moment, "DD-MM-YYYY").format(
              "D MMMM, YYYY",
            );
          });
          this.showLoader = false;
          this.zones = response.data;
        })
        .catch((error) => {});
    },

    getPriceLog() {
      this.showLoader = true;
      this.priceChangeLogLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/PriceChangeLog/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig(),
        )
        .then((response) => {
          this.priceChangeLogLoader = false;
          response.data.sort((a, b) => {
            return a.name > b.companyName ? 1 : -1;
          });

          response.data.sort((a, b) => {
            return a.product > b.product ? 1 : -1;
          });
          response.data.forEach((x, index) => {
            x.index = index + 1;
            x.date = this.$moment(x.date).format("MMMM Do YYYY, h:mma");
            x.currentPrice = this.convertThousand(x.currentPrice);
            x.previousPrice = this.convertThousand(x.previousPrice);
          });
          this.showLoader = false;

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.priceChangeLogLoader = false;
          this.showLoader = false;
        });
    },

    getApprovalList() {
      this.showLoader = true;
      // this.priceChangeLogLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/PriceChanges/Company/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate2}&endDate=${this.endDate2}`,
          configObject.authConfig(),
        )
        .then((response) => {
          this.priceChangeLogLoader = false;
          // response.data.sort((a, b) => {
          //   return a.name > b.companyName ? 1 : -1;
          // });
          // response.data.sort((a, b) => {
          //   return a.product > b.product ? 1 : -1;
          // });
          response.data.forEach((x, index) => {
            x.index = index + 1;
            x.date = this.$moment(x.date).format("MMMM Do YYYY, h:mma");
            if (x.oldPrice == null) {
              x.oldPrice = "-";
            }
            if (x.branchNames.includes(",")) {
              x.branchNames = this.processString(x.branchNames);
            }
            // x.price = this.convertThousand(x.price);
            // x.oldPrice = this.convertThousand(x.oldPrice);
          });
          this.showLoader = false;
          // this.approvalList = response.data;
          this.$refs.dataGrid2.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid2();
        })
        .catch((error) => {
          this.priceChangeLogLoader = false;
          this.showLoader = false;
        });
    },
    processString(inputString) {
      // Split the string by commas
      const items = inputString.split(",").map((item) => item.trim());

      // Get the first two items
      const firstTwo = items.slice(0, 2).join(", ");

      // Count the remaining items
      const remainingCount = items.length - 2;

      // Create a string with the count of remaining items
      const remainingString =
        remainingCount > 0 ? ` +${remainingCount} more` : "";

      return `${firstTwo} ${remainingString}`;
    },
    toggleBranchListDropdown() {
      this.showBranchListDropDown = !this.showBranchListDropDown;
    },
    revertNumber(number) {
      return Number(number.replace(/[^0-9.]+/g, ""));
    },
  },
};
</script>

<style scoped>
@keyframes flicker {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
.flicker-text {
  animation: flicker 3s infinite;
}
</style>
